export enum LESSON_TYPE {
  LIVE = 'live',
  VOD = 'vod',
}
